import { Marketplace, MarketplaceCode } from "../../domain/entities/Marketplace"
import { IMarketplaceRepository } from "../../domain/repositories/marketplaceRepository"
import { Endpoint } from "../network/endpoint"
import { HttpManager } from "../network/interface/HttpManager"

export class MarketplaceRepositoryImpl implements IMarketplaceRepository {
	private _http: HttpManager

	constructor({ HttpManager }: { HttpManager: HttpManager }) {
		this._http = HttpManager
	}

	async getMarketplace(code: MarketplaceCode): Promise<Marketplace> {
		try {
			const response = await this._http.requestNewApi({
				method: "GET",
				url: Endpoint.MARKETPLACE.replace(":marketplaceCode", code),
				headers: {
					Authorization: `Bearer ${localStorage.getItem("token") || ""}`
				}
			})
			const fee = response.data?.giftcardFee ?? response.data?.data?.giftcardFee
			return new Marketplace(code, fee)
		} catch (error) {
			console.error(`Error fetching marketplace ${code}:`, error)
			return new Marketplace(code, undefined)
		}
	}

	async updateMarketplace(code: MarketplaceCode, giftcardFee: number): Promise<Marketplace> {
		try {
			const response = await this._http.requestNewApi({
				method: "PATCH",
				url: Endpoint.MARKETPLACE.replace(":marketplaceCode", code),
				data: { giftcardFee },
				headers: {
					Authorization: `Bearer ${localStorage.getItem("token") || ""}`
				}
			})
			const fee = response.data?.giftcardFee ?? response.data?.data?.giftcardFee ?? giftcardFee
			return new Marketplace(code, fee)
		} catch (error) {
			console.error(`Error updating marketplace ${code}:`, error)
			throw error
		}
	}

	async updateMarketplaceLandingReviews(marketplace: "ES" | "MX", reviews: any[]): Promise<void> {
		try {
			const patchUrl = Endpoint.MARKETPLACE_LANDING_REVIEWS.replace(":marketplace", marketplace)
			const patchData = {
				reviews: reviews.map(review => ({
					id: review.id,
					weight: review.weight ?? 1
				}))
			}

			await this._http.requestNewApi({
				method: "PATCH",
				url: patchUrl,
				data: patchData,
				headers: {
					Authorization: `Bearer ${localStorage.getItem("token") || ""}`
				}
			})
		} catch (error: any) {
			throw error
		}
	}
}
